<template>
  <div v-if="element" class="element-wrapper">
    <!-- <img :style="`width:100%; height:100%; opacity: ${element.opacity / 100};`" :src="element.imgSrc"> -->
    <div :class="element['playing'] && 'animated ' + this.element['animatedName']" :style="styleAnime()" @click="handleElementClick">
      <div class="ql-editor" v-if="element.isTextarea">
        <div :style="`width: ${this.element.width}px; height: ${this.element.height}px`" v-html="element.text"></div>
      </div>
      <div :style="getStyleBasic()" v-else>{{ element.text }}</div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'CompText',
  methods: {
    styleAnime() {
      if (!this.element) return ''
      return {
        animationIterationCount: this.element.loop ? 'infinite' : 'initial',
        animationDuration: this.element.duration + 's',
        animationDelay: this.element.delay + 's'
      };
    },
    getStyleBasic() {
      if (!this.element) return ''
      return {
        width: this.element.width + 'px',
        lineHeight: this.element.lineHeight,
        color: this.element.color,
        textAlign: this.element.textAlign,
        fontSize: this.element.fontSize + 'px',
        fontWeight: this.element.fontWeight,
        'font-family': this.element.fontFamily,
        opacity: this.element.opacity / 100,
        transform: `rotate(${this.element.transform}deg)`,
        backgroundColor: this.element.bgColor
      };
    },
    handleElementFunsInit () {
      const ele = this.$el
      const _key = this.element._key
      const eventsBinding = this.element.eventsBinding || null
      if (!eventsBinding || !eventsBinding.list || eventsBinding.list.length < 1) return
      this.eventsBinding = eventsBinding
      ele.addEventListener('click', this.handleElementClick)
    },
    handleElementClick (ev) {
      ev.stopPropagation()
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onclick',
        eventData: {
          value: null,
          data: this.plugin,
          event: ev
        }
      })
    }
  },
  beforeDestroy () {
    this.$ele && this.$ele.removeEventListener('click', this.handleElementClick)
  },
  props: {
    element: {
      type: Object,
      default: null,
      require: true
    }
  },
  components: {},
  data: () => {
    return {
      eventsBinding: null
    }
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.handleElementFunsInit()
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onmounted',
        eventData: {
          value: null,
          data: this.plugin,
          event: null
        }
      })
    })
  }
}
</script>

<style lang='less' scoped>
.element-wrapper {
  width: 100%;
  height: 100%;
}
/deep/ .ql-editor {
  em {
    font-style: italic;
    font-weight: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
}
</style>
